import React from 'react';

interface UserAvatarProps {
  photoURL?: string;
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ 
  photoURL, 
  name = 'User', 
  size = 'md',
  className = ''
}) => {
  const [imageError, setImageError] = React.useState(false);

  const sizeClasses = {
    xs: 'h-6 w-6',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const textSizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-2xl'
  };

  const getInitials = (name: string): string => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // Reset error state when photoURL changes
  React.useEffect(() => {
    setImageError(false);
  }, [photoURL]);

  const showImage = photoURL && !imageError;

  return (
    <div className={`${sizeClasses[size]} rounded-full bg-gradient-to-br from-accent to-info flex items-center justify-center overflow-hidden flex-shrink-0 ${className}`}>
      {showImage ? (
        <img 
          src={photoURL} 
          alt={name} 
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <span className={`${textSizes[size]} font-bold text-accent`}>
          {getInitials(name)}
        </span>
      )}
    </div>
  );
};

export default UserAvatar;

